<template>
    <div>
      <!-- 属性类型选择器 -->
      <div v-if="currentStep === 'selectType'" class="attribute-selector-overlay" @click.self="cancelWizard">
        <div class="attribute-selector" @click.stop>
          <h4>选择属性类型</h4>
          <button class="selector-btn" @click="selectAttributeType('STR')">添加文字属性 (STR)</button>
          <button class="selector-btn" @click="selectAttributeType('IMG')">添加图片属性 (IMG)</button>
          <button class="selector-btn" @click="selectAttributeType('HML')">添加HTML属性 (HML)</button>
          <button class="selector-btn cancel-btn" @click="cancelWizard">取消</button>
        </div>
      </div>
  
      <!-- 属性名输入框 -->
      <div v-if="currentStep === 'enterName'" class="attribute-name-input-overlay" @click.self="cancelWizard">
        <div class="attribute-name-input-modal" @click.stop>
          <h4>输入 {{ selectedType }} 属性名</h4>
          <input
            ref="nameInputRef"
            v-model="attributeName"
            type="text"
            placeholder="请输入属性名"
            @keyup.enter="confirmAttribute"
          />
          <div class="attribute-name-input-footer">
            <button class="selector-btn confirm-btn" @click="confirmAttribute">确定</button>
            <button class="selector-btn cancel-btn" @click="goBackToTypeSelection">返回</button>
            <!-- 或者直接取消: <button class="selector-btn cancel-btn" @click="cancelWizard">取消</button> -->
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { defineComponent, ref, nextTick } from 'vue';
  import { ElMessage } from 'element-plus';
  
  export default defineComponent({
    name: 'AddDynamicAttributeWizard',
    emits: ['attribute-added', 'wizard-cancelled'], // 声明事件
    setup(props, { emit }) {
      const currentStep = ref('selectType'); // 'selectType' or 'enterName'
      const selectedType = ref(null);
      const attributeName = ref('');
      const nameInputRef = ref(null); // 用于聚焦
  
      /** 选择属性类型，进入下一步 */
      const selectAttributeType = (type) => {
        selectedType.value = type;
        currentStep.value = 'enterName';
        attributeName.value = ''; // 清空名称
        // 自动聚焦到输入框
        nextTick(() => {
          nameInputRef.value?.focus();
        });
      };
  
      /** 确认属性名称和类型，触发事件 */
      const confirmAttribute = () => {
        const trimmedName = attributeName.value.trim();
        if (!trimmedName) {
          ElMessage.warning('属性名不能为空！');
          return;
        }
        emit('attribute-added', { type: selectedType.value, name: trimmedName });
        resetWizard(); // 重置状态以便下次使用
      };
  
      /** 返回到类型选择步骤 */
      const goBackToTypeSelection = () => {
        currentStep.value = 'selectType';
        selectedType.value = null;
        attributeName.value = '';
      };
  
      /** 取消整个添加流程 */
      const cancelWizard = () => {
        emit('wizard-cancelled');
        resetWizard();
      };
  
      /** 重置向导状态 */
      const resetWizard = () => {
        currentStep.value = 'selectType';
        selectedType.value = null;
        attributeName.value = '';
      };
  
      return {
        currentStep,
        selectedType,
        attributeName,
        nameInputRef,
        selectAttributeType,
        confirmAttribute,
        goBackToTypeSelection,
        cancelWizard,
      };
    },
  });
  </script>
  
  <style scoped>
  /* 将原来 ProductFormModal 中与这两个小模态框相关的 CSS 样式复制到这里 */
  /* 例如 .attribute-selector-overlay, .attribute-selector, .attribute-name-input-overlay, .attribute-name-input-modal 等 */
  .attribute-selector-overlay,
  .attribute-name-input-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1002; /* 比主模态框高一层 */
   }
  
  .attribute-selector,
  .attribute-name-input-modal {
    background: #ffffff;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    width: 300px;
    text-align: center;
  }
  
  .attribute-selector h4,
  .attribute-name-input-modal h4 {
    margin: 0 0 15px;
    font-size: 16px;
    color: #333;
  }
  
  .selector-btn {
    display: block;
    width: 100%;
    padding: 10px;
    margin: 5px 0;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    font-size: 14px;
    transition: all 0.3s ease;
  }
  .selector-btn:not(.cancel-btn) {
    background: #5a9bd4;
    color: white;
  }
  .selector-btn:not(.cancel-btn):hover {
    background: #4a8bc2;
  }
  .cancel-btn {
    background: #ffffff;
    color: #666;
    border: 1px solid #d9d9d9;
  }
  .cancel-btn:hover {
    background: #f1f3f5;
  }
  
  .attribute-name-input-modal input {
    width: 90%;
    padding: 10px;
    border: 1px solid #d9d9d9;
    border-radius: 8px;
    margin-bottom: 15px;
    font-size: 14px;
  }
  
  .attribute-name-input-footer {
    display: flex;
    gap: 10px;
    justify-content: center;
  }
  
  .confirm-btn {
    background: #5a9bd4;
    color: white;
  }
  .confirm-btn:hover {
    background: #4a8bc2;
  }
  </style>